import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountState, ProAccount } from '@account-users/account/models';

@Component({
  selector: 'app-pro-account-ids',
  templateUrl: './pro-account-ids.component.html',
  styleUrls: ['./pro-account-ids.component.scss'],
})
export class ProAccountIdsComponent implements OnInit {
  @Input() proAccounts: ProAccount[];
  @Input() proAccountsIsLoading: boolean;
  @Input() mappedProIds: number[];
  @Input() canPlaceOrders: boolean;
  @Input() loadingProAccountIds: boolean;
  @Input() accountState: AccountState;
  @Output() proAccountNewLink = new EventEmitter();
  @Output() proAccountDeleteLink = new EventEmitter<{
    proAccountId: number;
    proAccountName: string;
  }>();

  AccountState = AccountState;
  edit = false;
  addNew = false;
  editAccountMessage: string;

  ngOnInit() {
    this.editAccountMessage = this.canPlaceOrders
      ? null
      : 'You do not have required permission to edit these settings';
  }

  onEdit() {
    this.edit = !this.edit;
    this.addNew = false;
  }
  toggleAddNew() {
    this.addNew = !this.addNew;
  }
  onSaveNewProLink(newId: number) {
    this.proAccountNewLink.emit(newId);
    this.addNew = false;
  }

  isMappedToMigration(proAccountId) {
    return this.mappedProIds.includes(proAccountId.toString());
  }

  deleteLink({
    proAccountId,
    proAccountName,
  }: {
    proAccountId: number;
    proAccountName: string;
  }) {
    if (!this.isMappedToMigration(proAccountId)) {
      this.proAccountDeleteLink.emit({ proAccountId, proAccountName });
    }
  }
}
